export async function downloadFile(path: string) {
  const link = document.createElement('a')
  link.href = '/api' + path
  document.body.appendChild(link)

  link.click()
  // 5. Clean up and remove the link

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  link.parentNode.removeChild(link)
}
